import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionsEvent from '../../event/redux/actions';
import AdminLayout from '../AdminLayout';
import { API } from '../../../helper/api';
import Form from './Form';
import { STATUS, EVENT, formatEvent, SETEVENT } from './Constants';
import { uploadFiles } from './UploadImage';
import { Location } from '../../../helper/map/Constants';
import { Modal, Steps, DatePicker, Select, Row, Col, Switch, Icon, Button, Popconfirm, Alert, Progress} from 'antd';
import moment from "moment";

export const createPrices = (prices, eventId) => Promise.all(prices.map(price => API.post('/price/', { amount: price.amount, roleId: price.role, eventId: eventId})))

export class CreateEvent extends Component {
  static propTypes = {

  };

  state = {
    event: this.props.location.state ? Object.assign(SETEVENT(this.props.location.state.event), {restrictedRolesList: this.props.location.state.event.restrictedRoles.map(e => e.roleId)}) : Object.assign(EVENT(), {location: Location.parse("default")}),
    prices: this.props.location.state ? this.props.location.state.event.prices.map(({ roleId, amount, id}) => ({role: roleId, amount, id })) || [] : [], //this.props.location.state.price ||
    moderators: (this.props.location.state && this.props.location.state.event.moderators) ? this.props.location.state.event.moderators.map(({ id, user}) => ({ id: id, key: user.id, label: user.firstName + " " + user.lastName })) : [],
    files: (this.props.location.state && this.props.location.state.event.images) ? this.props.location.state.event.images.map(({ imageId, url }) => ({ imageId, uid: imageId, url: "http://localhost:5000/" + url })) : [],
    visible_modal: false,
    modal_duplication: false,
    activate_duplication: false,
    date_duplication: moment(),
    week_duplication: 1,
    step_duplication: 1,
    modal_mode: STATUS.DRAFT,
    progress_duplication: 0,
    status_duplication: "process"
  };

  createEvent = (event, status) => {
    return this.props.actions.addEvent(formatEvent(event, status))
      .then((res) => {
        return res.data.id;
      })
      .then((id) => {
        for(const category of this.state.event.eventCategory)
          API.get('/event/'+id+'/category/'+ category)
        return id;
      })
      .then((id) => {
        for(const moderator of this.state.moderators)
          API.post('/user/temporary_role/' + moderator.key + '/'+ this.props.ROLE_ID.MODERATOR +'/' + id )

        return id;
      })
      .then((id) => {
        createPrices(this.state.prices, id)

        return id;
      })
      .then((id) => {
        this.state.files.length > 0  ? uploadFiles(id, this.state.files) : false

        return id;
      })
  }

  modal = () => {
    let events = [];
    let event = Object.assign({}, this.state.event);

    if(event.openAt && this.state.activate_duplication){
      while(moment(event.openAt).add(this.state.week_duplication, "week").isSameOrBefore(this.state.date_duplication, 'day')){
        event.openAt = moment(event.openAt).add(this.state.week_duplication, "week")
        event.closeAt = moment(event.closeAt).add(this.state.week_duplication, "week")
        event.startAt = moment(event.startAt).add(this.state.week_duplication, "week")
        event.endAt = moment(event.endAt).add(this.state.week_duplication, "week")

        events.push(Object.assign({}, event));
      }
    }

    /*
      FOOTER
    */
    let footer = this.state.step_duplication === 1 || this.state.status_duplication === "error" ? [
      <Button key="back" onClick={() => this.setState({
        modal_duplication: false,
        date_duplication: moment(),
        activate_duplication: false,
        week_duplication: 1,
        step_duplication: 1,
        progress_duplication: 0,
        status_duplication: "process"
      })} >Annuler</Button>
    ] : null;

    if(this.state.step_duplication === 1)
    {
      if(this.state.activate_duplication) {
        footer.push(
          <Popconfirm 
            title={"Cet évenements va être dupliqué " + events.length + " fois, êtes vous sûr de continuer ? "} 
            onConfirm={() => {
              this.setState({ step_duplication: 2 }); 

              const all_events = [ this.state.event, ...events ];
              let count = 0;
              Promise.all(all_events
                .map(async (event) => await this.createEvent(event, this.state.modal_mode).then(() => { count++; this.setState({ progress_duplication: Math.round( (count / all_events.length) * 100)}) })))
                .then(() => setTimeout(() => this.props.history.push('/admin/events/'), 1000) )
                .catch(() => this.setState({ status_duplication: "error" }))
            }}
            okText="Oui"
            cancelText="Non">
            <Button key="submit" type="primary">
              OK
            </Button>
          </Popconfirm>
        )
      } else {
        footer.push(
          <Button key="submit" type="primary" 
            onClick={
              () => { 
                this.setState({ step_duplication: 2 }); 
                this.createEvent(this.state.event, this.state.modal_mode)
                .then((id) => setTimeout(() => this.props.history.push('/admin/events/update/' + id), 1000) )
                .catch(() => this.setState({ status_duplication: "error" }))
              }
            }
          >
            Aucun duplicata
          </Button>
        )
      }
    }

    //end of footer

    return (
    <Modal
      visible={this.state.modal_duplication}
      maskClosable
      footer={footer}
      width={700}
      closable={false}
    >
     <Steps size="small" current={this.state.step_duplication} status={this.state.status_duplication}>
        <Steps.Step title="Évenement" />
        <Steps.Step title="Duplicata" />
        <Steps.Step title={ this.state.modal_mode === STATUS.DRAFT ? "Brouillon" : "Publication" } icon={this.state.step_duplication === 2 && this.state.status_duplication === "process" ? <Icon type="loading" /> : null} />
      </Steps>
      {
        this.state.step_duplication === 1 ?
      <div>
        <Alert style={{marginTop: 30}} message="Les dates d'inscriptions et de l'évenement sont décalés de N semaines" type="info" showIcon />
        <Row style={{marginTop: 15}}>
          <Col span={22}>
            <h2><Icon type="copy" theme="filled" /> {events.length} duplicata(s) </h2>
          </Col>
          <Col span={2}>
            <Switch 
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />}
              checked={this.state.activate_duplication} 
              onChange={(activate_duplication) => this.setState({ activate_duplication: activate_duplication })}/>
          </Col>
        </Row>
        <Row>
          Toutes les
          <Select 
            value={this.state.week_duplication}
            disabled={!this.state.activate_duplication}
            onChange={(week_duplication) => this.setState({ week_duplication })}
            style={{ width: 50, margin: "0 10px" }}>
            { new Array(9).fill(3).map((v, i) => <Select.Option value={i+1}>{i+1}</Select.Option>)}
          </Select>
          semaines,
          jusqu'au
          <DatePicker
            style={{ width: 175, margin: "0 10px" }}
            format="Do MMMM YYYY"
            closable={false}
            disabled={!this.state.activate_duplication}
            disabledDate={(date) => date.isBefore(moment())}
            value={this.state.date_duplication}
            onChange={(date_duplication) => this.setState({ date_duplication })}
            />
        </Row>
      </div>
      : 
      (this.state.step_duplication === 2 && this.state.activate_duplication ?
        <Progress percent={this.state.progress_duplication} status={this.state.status_duplication === "error" ? "exception" : null}/>
        : '')
      }
    </Modal>)
  }
  render() {
    return (
      <AdminLayout
        title="AJOUTER UN ÉVÉNEMENT"
        loading={this.state.loading}
        back="/admin/events"
        buttons={
          [{
            icon: "eye-o",
            type: "dashed",
            name: "APERÇU",
            onClick: () => this.setState({visible_modal : true})
          },
          {
            onClick: () => this.setState( { modal_duplication: true, modal_mode: STATUS.DRAFT } ),
            icon: "save",
            type: "default",
            name: "ENREGISTRER",
            loading: this.props.event.status.addEvent.pending,
            disabled: this.props.event.status.addEvent.pending
          },
          {
            onClick: () => this.setState( { modal_duplication: true, modal_mode: STATUS.PENDING } ),
            icon: "cloud-upload",
            name: "PUBLIER",
            loading: this.props.event.status.addEvent.pending,
            disabled: this.props.event.status.addEvent.pending
          }
          ]
        }
      >
        <Form
          event={this.state.event}
          files={this.state.files}
          prices={this.state.prices}
          addFile={(file) => this.setState(({ files }) => ({ files: [...files, file ] }))}
          addPrice={(price) => this.setState(({ prices }) => ({ prices: [...prices, price ] }))}
          removePrice={(price) => this.setState(({ prices }) => ({ prices: prices.filter(p => p.role !== price.role ) }))}
          removeFile={(file) => {
            this.setState(() => {
              const filesLocal =  this.state.files.filter(e => e.uid !== file.uid);

              if (filesLocal.length !== this.state.files.length) {
                return ({
                  files:  filesLocal
                })
              }
            });
          }}
          moderators={this.state.moderators}
          onModeratorChange={(moderators) => this.setState({ moderators })}
          onEventChange={(value) => this.setState({ event: Object.assign(this.state.event, value) })}
          preview={this.state.visible_modal}
          closePreview={() => this.setState({visible_modal : false})}
        />
        {this.modal()}
      </AdminLayout >
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
    event: state.event,
    ROLE_ID: state.admin.ROLE_ID
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actionsEvent }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEvent);


// WEBPACK FOOTER //
// ./src/features/admin/events/Create.js